import React, { useEffect, useState } from "react";
import Navbar from "../sections/common/Navbar";
import Footer from "../sections/common/Footer";
import { detailsPageApi } from "../apis/detailsPages/detailsPagesApi";

function PrivacyPolicy() {
  const [details, setDetails] = useState([]);

  const fetchPrivacyPolicy = async () => {
    const response = await detailsPageApi("privacy-policy");
    const detailsData = response.data.data.content;
    console.log(detailsData);
    setDetails(detailsData);
  };

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  return (
    <div>
      <Navbar />
      <section className="listing-banner">
        <h1>Privacy Policy</h1>
      </section>
      <section className="container blog-details-page-location">
        <p>Home / Privacy Policy</p>
      </section>
      <section className="container blog-details-page-location py-5">
        <div dangerouslySetInnerHTML={{ __html: details }}></div>
      </section>

      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
